import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingHeadingComponent } from './landing-heading/landing-heading.component';
import { LandingBodyComponent } from './landing-body/landing-body.component';
import { LandingFooterComponent } from './landing-footer/landing-footer.component';
import { InitialFormComponent } from './landing-body/initial-form/initial-form.component';


import { ReactiveFormsModule } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { PayPageComponent } from './landing-body/pay-page/pay-page.component';
import { ConfirmPageComponent } from './landing-body/confirm-page/confirm-page.component';


import { HttpClientModule } from '@angular/common/http';
import { AuthorizeNetPageComponent } from './authorize-net-page/authorize-net-page.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingHeadingComponent,
    LandingBodyComponent,
    LandingFooterComponent,
    InitialFormComponent,
    PayPageComponent,
    ConfirmPageComponent,
    AuthorizeNetPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [FormControl],
  bootstrap: [AppComponent]
})
export class AppModule { }
